import React from 'react';
import {
  Grid,
  CircularProgress,
  Button,
  makeStyles,
  colors,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import Routes, { CreateRecipePageSteps } from 'config/routes';

import useCreateRecipeRequest from 'pages/create_recipe/useCreateRecipeRequest';

import Title from 'components/typography/Title';
import Description from 'components/typography/Description';

const useStyles = makeStyles({
  button: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  goBackButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const RequestBody = ({ recipe, idempotencyToken, exitPage }) => {
  const {
    isLoading,
    retryRequest,
    hasFailed,
    isRecipeInvalid,
    wasRecipeCreated,
  } = useCreateRecipeRequest(recipe, idempotencyToken);

  return (
    <Grid container justify="center">
      <Grid item>
        {isLoading && <LoadingIndicator></LoadingIndicator>}
        {wasRecipeCreated && (
          <RecipeCreated exitPage={exitPage}></RecipeCreated>
        )}
        {hasFailed && (
          <ErrorIndicator onTryAgainButtonPress={retryRequest}></ErrorIndicator>
        )}
        {isRecipeInvalid && <InvalidRecipeIndicator></InvalidRecipeIndicator>}
      </Grid>
    </Grid>
  );
};

const RecipeCreated = ({ exitPage }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Title>Recipe created</Title>
      </Grid>
      <Grid item style={{ marginTop: 32 }}>
        <Link to={Routes.MY_RECIPES} style={{ textDecoration: 'none' }}>
          <Button className={classes.button}>GO TO MY RECIPES</Button>
        </Link>
      </Grid>
      <Grid item style={{ marginTop: 16 }}>
        <Button className={classes.goBackButton} onClick={exitPage}>
          GO BACK
        </Button>
      </Grid>
    </Grid>
  );
};

const LoadingIndicator = () => {
  return (
    <Grid container direction="column" alignItems="center" spacing={4}>
      <Grid item>
        <Title>Creating recipe</Title>
      </Grid>
      <Grid item>
        <CircularProgress style={{ color: colors.red[400] }}></CircularProgress>
      </Grid>
    </Grid>
  );
};

const ErrorIndicator = ({ onTryAgainButtonPress }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center" spacing={4}>
      <Grid item>
        <Description>
          Recipe creation <b>failed</b>
        </Description>
      </Grid>

      <Grid item>
        <Button onClick={onTryAgainButtonPress} className={classes.button}>
          Try Again
        </Button>
      </Grid>
    </Grid>
  );
};

const InvalidRecipeIndicator = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Description>
          It seems that the recipe is <b>invalid</b>
        </Description>
      </Grid>
      <Grid item>
        <Link
          to={Routes.createRecipe(CreateRecipePageSteps.confirmation)}
          style={{ textDecoration: 'none' }}
        >
          <Button variant="contained" className={classes.button}>
            Check recipe information
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};

export default RequestBody;
